// extracted by mini-css-extract-plugin
module.exports = {"empty":"empty_empty__2KLJW","emptyImage":"empty_emptyImage__2ZupT","emptyText":"empty_emptyText__1Cf95"};